import { TfiAngleLeft } from "react-icons/tfi";

const BackButton = () => {
  return (
    <button className="font-pop font-bold text-base text-white flex items-center gap-x-6 py-2.5 px-6 bg-primary mt-5 ">
      <TfiAngleLeft className="cursor-pointer" />
      <p>Back</p>
    </button>
  );
};

export default BackButton;
